import benjImg from '../../assets/Team/MemberChoiceItemPhotos/Benjamin-Proulx-Mathers-7b.jpg';
import chrisImg from '../../assets/Team/MemberChoiceItemPhotos/Christian-Lagueux-7b.jpg';
import dannyImg from '../../assets/Team/MemberChoiceItemPhotos/Danny-Black-Background4.jpg';
import joshImg from '../../assets/Team/MemberChoiceItemPhotos/Josh9-578x867.jpg';
import sebImg from '../../assets/Team/MemberChoiceItemPhotos/Seb7.jpg';

export const teamMemberData = [
    {
        id: 1,
        name: 'Christan Lagueux',
        role: 'FOUNDER - PRODUCER - COMPOSER',
        image: chrisImg,
    },
    {
        id: 2,
        name: 'Benjamin Proulx',
        role: 'COMPOSER',
        image: benjImg,
    },
    {
        id: 3,
        name: 'Daniel de los Reyes',
        role: 'CREATIVE DEVELOPMENT',
        image: dannyImg,
    },
    {
        id: 4,
        name: 'Joshua Eagan',
        role: 'PARTNER - STUDIO C / THE STEAKHOUSE STUDIO',
        image: joshImg,
    },
    {
        id: 5,
        name: 'Sébastien Laurendeau',
        role: 'MUSICAL DIRECTOR - COMPOSER',
        image: sebImg,
    },
];
